import { Link } from "wouter";
import { Button } from "@/components/ui/button";
import { FileQuestion, Home } from "lucide-react";
import { SEO } from "@/components/SEO";

export default function NotFound() {
  return (
    <div className="min-h-screen w-full flex flex-col items-center justify-center bg-background p-4">
      <SEO title="Page Not Found — LRScribe" noindex />
      <div className="text-center max-w-md mx-auto">
        <div className="w-24 h-24 bg-muted rounded-3xl flex items-center justify-center mx-auto mb-8 animate-in zoom-in duration-500">
          <FileQuestion className="w-12 h-12 text-muted-foreground" />
        </div>
        
        <h1 className="text-4xl font-heading font-extrabold text-foreground mb-4">
          Page Not Found
        </h1>
        
        <p className="text-lg text-muted-foreground mb-8">
          The page you are looking for doesn't exist or has been moved. 
          Let's get you back to safety.
        </p>

        <Link href="/">
          <Button size="lg" className="gap-2 shadow-lg shadow-primary/20">
            <Home className="w-4 h-4" />
            Back to Home
          </Button>
        </Link>
      </div>
    </div>
  );
}
